import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimeSelect from './seat/TimeSelect';
import SeatSelect from './seat/SeatSelect';
import SeatInfoDialog from './seat/SeatInfoDialog';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault, getNowTimeStamp } from './Utils.js';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import SeatChart from './SeatChart';

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    StartDateTextField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 280,
    },
    DateTextField: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 280,
    },
    currentPrepaidTime: {
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(2),
        width: 180,
    },
    seatButton: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

export default function ReserveRoom() {
    const classes = useStyles();

    const [time, setTime] = React.useState();
    const [seat, setSeat] = React.useState();
    const [seatList, setSeatList] = React.useState([]);

    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const [currentPrepaidTime, setCurrentPrepaidTime] = React.useState();
    const [currentMonthly, setCurrentMonthly] = React.useState();

    const [startDateTime, setStartDateTime] = React.useState('');

    const [reserveList, setReserveList] = React.useState();


    const [seatMap, setSeatMap] = React.useState(false);
    const [seatChart, setSeatChart] = React.useState(false);
    const [allReserveList, setAllReserveList] = React.useState([]);

    const onDateChanged = (e) => {

        //테이블 리스트
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=' + startDateTime + '&time=' + time + '&isRoom=true',
            (data) => {
                setSeatList([data][0]);
                //setSeat([data][0][0].id);
            }
        );

        //계산
        setBill(time, seat);
    }

    const onTimeChanged = (t) => {
        setTime(t);

        //테이블 리스트
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=' + startDateTime + '&time=' + t + '&isRoom=true',
            (data) => {
                setSeatList([data][0]);
                //setSeat([data][0][0].id);
            }
        );

        //계산
        setBill(t, seat);
    };

    const onTableChanged = (tableId) => {
        setSeat(tableId);

        //계산
        setBill(time, tableId);
    };

    useEffect(() => {

        setStartDateTime(getNowTimeStamp());

        //내가 예약한 자리 목록
        //fetchDefault('/Payment/GetReserveSeatList',
        //    (data) => {
        //        setReserveList(data);
        //    }
        //);


        //테이블 리스트
        /*
        fetchDefault('/Payment/GetAvailableSeatList?startDateTime=&time=240&isRoom=true',
            (data) => {

                //이용시간 60으로 변경해서 한번 더
                if (data.length === 0) {
                    setTime(60);
                    fetchDefault('/Payment/GetAvailableSeatList?startDateTime=&time=60',
                        (data) => {
                            setSeatList([data][0]);
                            if ([data][0][0].id) {
                                setSeat([data][0][0].id);

                                //계산
                                setBill(time, [data][0][0].id);
                            }
                        }
                    );
                }
                else {
                    setSeatList([data][0]);
                    if ([data][0][0].id) {
                        setSeat([data][0][0].id);

                        //계산
                        setBill(time, [data][0][0].id);
                    }
                }
            }
        );
        */


        //월정액
        fetchDefault('/Payment/GetCurrentMonthly',
            (data) => {
                if (data.endDateTime) {
                    setCurrentMonthly(data.endDateTime.substring(0, 16));
                }
            }
        );

        //시간정액
        fetchDefault('/Payment/GetCurrentPrepaid',
            (data) => {
                setCurrentPrepaidTime(data.time);
            }
        );

        return () => {
        }
    }, []);

    const setBill = (time, tableId) => {
        fetchDefault('/Payment/GetBill?startDateTime=' + startDateTime + '&time=' + time + '&tableId=' + tableId,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }

    const cancelReserve = (id) => {

        fetchDefault('/Payment/CancelReservation?id=' + id,
            (data) => {
                //내가 예약한 자리 목록
                fetchDefault('/Payment/GetReserveSeatList',
                    (data) => {
                        setReserveList(data);
                    }
                );
            }
        );
    }


    //예약된 전체 자리 보기
    const GetAllSeatInfo = () => {

        fetchDefault('/Seat/GetAllSeatUseInfo',
            (data) => {
                setAllReserveList(data);
                setSeatMap(true);
            }
        );
    }


    const GetAllSeatChart = () => {
        setSeatChart(true);
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>스터디룸 이용하기</h2>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                스터디룸은 예약 후 이용가능합니다. (인원수 무관하게 1명만 예약)
                            </Typography>
                            <Typography variant="body1">
                                (월정액, 지정석 사용자는 하루 1시간 이내로 예약없이 이용가능합니다. 대신 이용중 스터디룸 예약자가 입장하면 자리를 바로 비워주세요.)
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {reserveList ? (
                    <Grid item xs={12}>
                        {reserveList.map(seat => (
                            <Card style={{ marginBottom: 5}}>
                                <CardContent>
                                    <Typography variant="body1">
                                        자리 : {seat.tableName}
                                    </Typography>
                                    <Typography variant="body1">
                                        시작 : {seat.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        종료 : {seat.endDateTime}
                                    </Typography>
                                </CardContent>
                                <CardActions>
                                    <Button size="small" onClick={() => cancelReserve(seat.id)}>
                                        취소하기
                                    </Button>
                                </CardActions>
                            </Card>
                        ))}
                    </Grid>
                ) : (<div></div>)}

                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 시작날짜를 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="datetime-local"
                        label="시작날짜"
                        className={classes.StartDateTextField}
                        type="datetime-local"
                        value={startDateTime}
                        onChange={e => setStartDateTime(e.target.value)}
                        onBlur={onDateChanged}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 이용시간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TimeSelect time={time} onTimeChanged={onTimeChanged} />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 이용을 원하시는 자리를 선택해주세요.
                    </Typography>

                    <Typography variant="body2">
                        (카페를 둘러보시고, 주변에 있는 자리번호를 확인하세요.)
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <SeatSelect tableList={seatList} seat={seat} onTableChanged={onTableChanged} />
                    {/*<SeatInfoDialog onTableChanged={onTableChanged} time={time} />*/}
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <img alt="loading..." src={require('../images/seats_v1.0.png')} style={{ width: 650 }} />
                    </Paper>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatChart}>
                        예약 현황표
                    </Button>
                    <Button className={classes.seatButton} variant="outlined" onClick={GetAllSeatInfo}>
                        예약 전체 보기
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        4. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} usePoint={usePoint} myPoint={myPoint} totalPrice={totalPrice} />
                </Grid>

                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/UseSeat?startDateTime=' + startDateTime + '&time=' + time + '&seat=' + seat} />
                </Grid>
            </Grid>




            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatMap}
                onClose={() => { setSeatMap(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    {allReserveList.map(seat => (
                        <Card style={{ marginBottom: 5 }}>
                            <CardContent>
                                <Typography variant="h6">
                                    {seat.tableName}
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        seat.time.split('/').map(t => {
                                            return <div style={{ marginBottom: 14, marginTop: 14 }}>{
                                                t.split('|').map(a => {
                                                    return <div>{a}</div>;
                                                })
                                            }</div>;

                                        })
                                    }
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}

                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatMap(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                fullWidth='true'
                maxWidth='md'
                open={seatChart}
                onClose={() => { setSeatChart(false) }}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <SeatChart />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => setSeatChart(false)}>
                        <Typography variant="h6">
                            확인
                        </Typography>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/ReserveRoom.js